import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "galery"
}
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "galery-title-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "center black" }, "Fotóalbum")
], -1)
const _hoisted_4 = { class: "navigation-wrapper" }
const _hoisted_5 = { class: "carousel__item" }
const _hoisted_6 = ["src", "alt", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!

  return (_ctx.galleryImages.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Carousel, {
            "items-to-show": 1.5,
            "wrap-around": false,
            class: _normalizeClass('gallery')
          }, {
            addons: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Navigation)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryImages, (slide, index) => {
                return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: slide.url,
                        alt: slide.name,
                        onClick: ($event: any) => (_ctx.showGallery(index))
                      }, null, 8, _hoisted_6)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["items-to-show"])
        ]),
        _createVNode(_component_vue_easy_lightbox, {
          visible: _ctx.isShowGalleryPopup,
          imgs: _ctx.lightBoxGalleryImages,
          index: _ctx.galleryIndex,
          onHide: _ctx.closeGallery
        }, null, 8, ["visible", "imgs", "index", "onHide"])
      ]))
    : _createCommentVNode("", true)
}